import { BaseDO } from './base.model';
import { ClientAddressDO } from './clientAddress.model';
import { ClientContactDO } from './clientContact.model';
import { ClientEmailDO } from './clientEmail.model';
import { OrganisationDO } from './organisation.model';
import { PersonDO } from './person.model';


export class ClientDO extends BaseDO {

    private id: Number;

    public externalClientNum: String = null;

    public clientNum: String = null;

    public deDupStatusCd: String = null;

    public statusCd: String = null;

    public clientTypeCd: String = null;

    public organisationDO: OrganisationDO = new OrganisationDO();

    public personDO: PersonDO = new PersonDO();

    public clientAddressList: ClientAddressDO[] = [];

    public clientContactDetailsList: ClientContactDO[] = [];

    public clientEmailList: ClientEmailDO[] = [];

    public blackListedFl: Boolean

    public duplicateClientNum: any

    public duplicateFl: any

    public fromEffectiveDT: any

    public preferredEmail: any

    public preferredMobileNum: any
    

    public getId(): Number {
        return this.id;
    }

    public setId(id: Number): void {
        this.id = id;
    }

    public getDeDupStatusCd(): String {
        return this.deDupStatusCd;
    }

    public setDeDupStatusCd(deDupStatusCd: String) {
        this.deDupStatusCd = deDupStatusCd;
    }

    public getStatusCd(): String {
        return this.statusCd;
    }

    public setStatusCd(statusCd: String) {
        this.statusCd = statusCd;
    }

    public getClientTypeCd(): String {
        return this.clientTypeCd;
    }

    public setClientTypeCd(clientTypeCd: String) {
        this.clientTypeCd = clientTypeCd;
    }

    public getOrganisationDO(): OrganisationDO {
        return this.organisationDO;
    }

    public setOrganisationDO(organisationDO: OrganisationDO) {
        this.organisationDO = organisationDO;
    }


    public getPersonDO(): PersonDO {
        return this.personDO;
    }

    public setPersonDO(personDO: PersonDO) {
        this.personDO = personDO;
    }

    public getClientAddressList(): ClientAddressDO[] {
        return this.clientAddressList;
    }

    public setClientAddressList(clientAddressList: ClientAddressDO[]) {
        this.clientAddressList = clientAddressList;
    }

    public getClientEmailList(): ClientEmailDO[] {
        return this.clientEmailList;
    }

    public setClientEmailList(clientEmailList: ClientEmailDO[]) {
        this.clientEmailList = clientEmailList;
    }

    public getClientContactList(): ClientContactDO[] {
        return this.clientContactDetailsList;
    }

    public setClientContactList(clientContactDetailsList: ClientContactDO[]) {
        this.clientContactDetailsList = clientContactDetailsList;
    }

    public getExternalClientNum(): String {
        return this.externalClientNum;
    }

    public setExternalClientNum(externalClientNum: String) {
        this.externalClientNum = externalClientNum;
    }

    public getClientNum(): String {
        return this.clientNum;
    }

    public setClientNum(clientNum: String) {
        this.clientNum = clientNum;
    }

}

export class ClientPersonDO extends BaseDO {

    private id: Number;

    public externalClientNum: String = null;

    public clientNum: String = null;

    public deDupStatusCd: String = null;

    public statusCd: String = null;

    public clientTypeCd: String = 'PERSON';

    public organisationDO: OrganisationDO = null;

    public personDO: PersonDO = new PersonDO();

    public clientAddressList: ClientAddressDO[] = [];

    public clientContactDetailsList: ClientContactDO[] = [];

    public clientEmailList: ClientEmailDO[] = [];

    public getId(): Number {
        return this.id;
    }

    public setId(id: Number): void {
        this.id = id;
    }

    public getDeDupStatusCd(): String {
        return this.deDupStatusCd;
    }

    public setDeDupStatusCd(deDupStatusCd: String) {
        this.deDupStatusCd = deDupStatusCd;
    }

    public getStatusCd(): String {
        return this.statusCd;
    }

    public setStatusCd(statusCd: String) {
        this.statusCd = statusCd;
    }

    public getClientTypeCd(): String {
        return this.clientTypeCd;
    }

    public setClientTypeCd(clientTypeCd: String) {
        this.clientTypeCd = clientTypeCd;
    }

    public getOrganisationDO(): OrganisationDO {
        return this.organisationDO;
    }

    public setOrganisationDO(organisationDO: OrganisationDO) {
        this.organisationDO = organisationDO;
    }


    public getPersonDO(): PersonDO {
        return this.personDO;
    }

    public setPersonDO(personDO: PersonDO) {
        this.personDO = personDO;
    }

    public getClientAddressList(): ClientAddressDO[] {
        return this.clientAddressList;
    }

    public setClientAddressList(clientAddressList: ClientAddressDO[]) {
        this.clientAddressList = clientAddressList;
    }

    public getClientEmailList(): ClientEmailDO[] {
        return this.clientEmailList;
    }

    public setClientEmailList(clientEmailList: ClientEmailDO[]) {
        this.clientEmailList = clientEmailList;
    }

    public getClientContactList(): ClientContactDO[] {
        return this.clientContactDetailsList;
    }

    public setClientContactList(clientContactDetailsList: ClientContactDO[]) {
        this.clientContactDetailsList = clientContactDetailsList;
    }

    public getExternalClientNum(): String {
        return this.externalClientNum;
    }

    public setExternalClientNum(externalClientNum: String) {
        this.externalClientNum = externalClientNum;
    }

    public getClientNum(): String {
        return this.clientNum;
    }

    public setClientNum(clientNum: String) {
        this.clientNum = clientNum;
    }

}


export class ClientOrgnizationDO extends BaseDO {

    private id: Number;

    public externalClientNum: String = null;

    public clientNum: String = null;

    public deDupStatusCd: String = null;

    public statusCd: String = null;

    public clientTypeCd: String = 'ORGANIZATION';

    public organisationDO: OrganisationDO = new OrganisationDO();

    public personDO: PersonDO = new PersonDO() ;

    public clientAddressList: ClientAddressDO[] = [];

    public clientContactDetailsList: ClientContactDO[] = [];

    public clientEmailList: ClientEmailDO[] = [];

    public getId(): Number {
        return this.id;
    }

    public setId(id: Number): void {
        this.id = id;
    }

    public getDeDupStatusCd(): String {
        return this.deDupStatusCd;
    }

    public setDeDupStatusCd(deDupStatusCd: String) {
        this.deDupStatusCd = deDupStatusCd;
    }

    public getStatusCd(): String {
        return this.statusCd;
    }

    public setStatusCd(statusCd: String) {
        this.statusCd = statusCd;
    }

    public getClientTypeCd(): String {
        return this.clientTypeCd;
    }

    public setClientTypeCd(clientTypeCd: String) {
        this.clientTypeCd = clientTypeCd;
    }

    public getOrganisationDO(): OrganisationDO {
        return this.organisationDO;
    }

    public setOrganisationDO(organisationDO: OrganisationDO) {
        this.organisationDO = organisationDO;
    }


    public getPersonDO(): PersonDO {
        return this.personDO;
    }

    public setPersonDO(personDO: PersonDO) {
        this.personDO = personDO;
    }

    public getClientAddressList(): ClientAddressDO[] {
        return this.clientAddressList;
    }

    public setClientAddressList(clientAddressList: ClientAddressDO[]) {
        this.clientAddressList = clientAddressList;
    }

    public getClientEmailList(): ClientEmailDO[] {
        return this.clientEmailList;
    }

    public setClientEmailList(clientEmailList: ClientEmailDO[]) {
        this.clientEmailList = clientEmailList;
    }

    public getClientContactList(): ClientContactDO[] {
        return this.clientContactDetailsList;
    }

    public setClientContactList(clientContactDetailsList: ClientContactDO[]) {
        this.clientContactDetailsList = clientContactDetailsList;
    }

    public getExternalClientNum(): String {
        return this.externalClientNum;
    }

    public setExternalClientNum(externalClientNum: String) {
        this.externalClientNum = externalClientNum;
    }

    public getClientNum(): String {
        return this.clientNum;
    }

    public setClientNum(clientNum: String) {
        this.clientNum = clientNum;
    }

}